export default {
  setAlertHeight(state, payload) {
    state.alertHeight += payload.alertHeight;

    return state;
  },
  setAccordionHeight(state, payload) {
    state.accordionHeight += payload.accordionHeight;

    return state;
  },
  searchPanelMobileOpen(state, payload) {
    state.searchPanelMobileOpen = payload.searchPanelMobileOpen;

    return state;
  },
  mainMenuMobileOpen(state, payload) {
    state.mainMenuMobileOpen = payload.mainMenuMobileOpen;

    return state;
  },
};
